var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 100,
    viewBox: "0 0 149 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.875 24.6463C129.358 28.3236 132.141 33.8751 134.715 39.7779C143.146 59.1505 138.282 78.4599 118.552 88.481C87.9121 103.995 41.5456 98.3896 17.6765 73.8652C12.3855 68.442 4.7528 61.8837 3.36909 50.0463C2.07983 39.0381 7.68549 30.2269 15.3103 23.5278C23.1092 16.648 33.0164 11.9507 40.1863 9.41133C71.506 -1.64547 119.854 0.213286 146.479 30.4452C147.034 31.0531 147.92 31.1102 148.492 30.5937C149.064 30.0772 149.131 29.1964 148.624 28.6174C121.216 -2.50015 71.4514 -4.62554 39.2168 6.75228C30.288 9.92563 17.2501 16.3412 8.82905 26.0148C3.08984 32.6362 -0.524296 40.754 0.560647 50.3485C2.01467 62.946 10.0427 70.0509 15.6559 75.8135C40.2954 101.135 88.204 107.017 119.817 90.9744C141.04 80.2141 146.358 59.4907 137.288 38.663C134.539 32.2847 131.411 26.3214 125.459 22.3305C124.802 21.8909 123.917 22.0542 123.52 22.7173C123.074 23.3514 123.267 24.2357 123.875 24.6463Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/circle2.c3e41e5169ee577cdf21c71847cfd89e.svg";
export { ForwardRef as ReactComponent };